import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_address_picker = _resolveComponent("address-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.type === 'add' ? '新增' : '修改',
    width: "500px",
    modelValue: _ctx.warehouseInfoDialogVisible,
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    "custom-class": "dialog-width-small el-dialog-inner-scroll",
    top: "5vh",
    onOpen: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleOpen())),
    onClose: _ctx.handleCancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, { onClick: _ctx.handleCancel }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.confirmUpdate
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-width": "100px",
        ref: "refForm",
        rules: _ctx.rules,
        model: _ctx.choosedItem
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "仓库名称：",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.choosedItem.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.choosedItem.name) = $event)),
                placeholder: "请输入仓库名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "仓库编号：",
            prop: "code"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                disabled: _ctx.type==='edit',
                modelValue: _ctx.choosedItem.code,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.choosedItem.code) = $event)),
                placeholder: "请输入仓库编号"
              }, null, 8, ["disabled", "modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "仓库地址：",
            prop: "area"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_address_picker, {
                province: _ctx.choosedItem.province,
                "onUpdate:province": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.choosedItem.province) = $event)),
                city: _ctx.choosedItem.city,
                "onUpdate:city": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.choosedItem.city) = $event)),
                area: _ctx.choosedItem.area,
                "onUpdate:area": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.choosedItem.area) = $event))
              }, null, 8, ["province", "city", "area"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "详细地址：",
            prop: "address"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.choosedItem.address,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.choosedItem.address) = $event)),
                placeholder: "请输入详细地址"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onClose"]))
}